import styled, { css } from 'styled-components';
import { media } from 'app/styles/variables';

interface IFullScreenSlidesStProps {
  withBackground?: boolean;
}

export const FullScreenSlidesSt = styled.div<IFullScreenSlidesStProps>`
  width: 100%;
  height: ${({ withBackground }) => (!withBackground ? '100%' : '15rem')};
  position: relative;
  display: flex;
`;

interface IFullScreenSlideStProps {
  withBackground?: boolean;
  offset?: number;
}

export const FullScreenSlideSt = styled.div<IFullScreenSlideStProps>`
  min-width: 100%;
  max-height: 100%;
  display: flex;
  justify-content: center;
  display: inline;
  transition: transform 0.3s;
  transform: ${({ offset }) =>
    `translate(calc((${-(offset * 100)}% / 2) + (${-(
      offset * 100
    )}% / 2)), 0) `};
  & > img {
    object-fit: contain;
  }
`;

export const SlideFullscreenSt = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
  max-width: 100%;
  ${media.xs(css`
    max-width: 75%;
  `)}
`;

export const SlideHeaderSt = styled.div`
  display: none;
  ${media.sm(
    css`
      height: 50px;
      align-items: center;
      display: flex;
      width: 100%;
      justify-content: flex-end;
      margin-bottom: 0.5rem;
    `,
  )};
`;

export const MobileFullscreenButtonSt = styled.div`
  position: absolute;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  top: 0;
  height: 50px;
  align-items: center;
  ${media.sm(
    css`
      display: none;
    `,
  )};
`;

export const FullscreenContainerSt = styled.div`
  position: fixed;
  z-index: 3000;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
`;

export const SlideContainerSt = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 2rem;
  gap: 0;
  transition: background 0.3s;
  max-width: 100%;
  ${media.sm(css`
    background: transparent;
    max-height: 75%;
    flex-direction: row;
    max-width: initial;
  `)};
`;
